import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import * as _ from "../../../util/lodash";
import React from 'react';
import { connect } from 'react-redux';
import { createComponent, PropTypes } from "../../../wayin-react";
import Actions from "./actions";
import Selectors from "./selectors";
var Form = createComponent({
  displayName: 'Form',
  propTypes: {
    children: PropTypes.node.isRequired,
    formId: PropTypes.string.isRequired,
    validations: PropTypes.object,
    isValid: PropTypes.bool.isRequired,
    isDirty: PropTypes.bool.isRequired
  },
  defaultProps: {
    validations: null
  },
  lifecycles: {
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.props.registerForm(this.props.formId, this.props.validations);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.deregisterForm(this.props.formId);
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this = this;

      //  We're going to only apply form field level validation for fields that changed
      if (!_.isEqual(this.props.formValues, nextProps.formValues) && nextProps.isDirty) {
        var changedFields = _filterInstanceProperty(_).call(_, _keysInstanceProperty(_).call(_, this.props.formValues), function (fieldId) {
          return nextProps.formValues[fieldId] !== _this.props.formValues[fieldId];
        });

        this.props.changeFormValues(this.props.formId, changedFields, nextProps.formValues, this.props.validations);
      }
    }
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement("div", null, p.children);
  }
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerForm: function registerForm(formId, validations) {
      return dispatch(Actions.registerForm(formId, validations));
    },
    deregisterForm: function deregisterForm(formId) {
      return dispatch(Actions.deregisterForm(formId));
    },
    changeFormValues: function changeFormValues(formId, fieldIds, formValues, validations) {
      return dispatch(Actions.changeFormValues(formId, fieldIds, formValues, validations));
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    formErrors: Selectors.getFormErrors(state, ownProps.formId),
    formValues: Selectors.getFormValues(state, ownProps.formId),
    isValid: Selectors.isFormValid(state, ownProps.formId),
    isDirty: Selectors.isFormDirty(state, ownProps.formId)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
//# sourceMappingURL=index.js.map